import { ViteReactSSG } from 'vite-react-ssg/single-page';
import App from './App';
import './index.css';

// Prerender the landing page to static HTML at build time (vite-react-ssg),
// then hydrate on the client. This puts the real content (headings, services,
// copy) into the server-delivered HTML so crawlers and AI agents that don't
// execute JavaScript can read the page. The interactive bits (theme/lang
// toggle, workflow mapper, bpmn-js viewer) all run inside effects/handlers,
// so they only activate after hydration — safe to skip during the build render.
export const createRoot = ViteReactSSG(<App />);
